// The one closed vocabulary used by the classifier and its override validator.
export const RELEASE_TYPES = Object.freeze([
  'official', 'unlicensed', 'homebrew', 'hack', 'prototype', 'demo',
  'subset', 'test_kit', 'invalid',
]);
export const LISTED_TYPES = Object.freeze(RELEASE_TYPES.slice(0, 6));
export const UNOFFICIAL_TYPES = Object.freeze(LISTED_TYPES.slice(1));
export const NON_GAME_TYPES = Object.freeze(RELEASE_TYPES.slice(6));
export const DEFAULT_RELEASE_TYPES = Object.freeze(['official']);

export const FACET_LABELS = Object.freeze({
  official: 'Official releases',
  unlicensed: 'Unlicensed',
  homebrew: 'Homebrew',
  hack: 'Hacks',
  prototype: 'Prototypes and betas',
  demo: 'Demos',
});
export const UNOFFICIAL_GROUP_LABEL = 'Unofficial';
export const BADGE_LABELS = Object.freeze({
  unlicensed: 'Unlicensed',
  homebrew: 'Homebrew',
  hack: 'Hack',
  prototype: 'Prototype',
  demo: 'Demo',
});
export const DETAIL_BADGE_LABELS = Object.freeze({
  beta: 'Beta',
  translation: 'Fan translation',
});

export const ROM_EXTENSIONS = Object.freeze([
  'nes', 'sfc', 'smc', 'gb', 'gbc', 'gba', 'md', 'gen', 'smd', '32x',
  'a26', 'bin', 'rom', 'n64', 'v64', 'z64', 'd64', 'd71', 'd81',
  'g64', 't64', 'prg', 'crt', 'tap',
]);

export const KNOWN_ROM_SYSTEMS = Object.freeze([
  'nes', 'snes', 'gb', 'gbc', 'gba', 'genesis', 'atari2600', 'c64', 'n64',
]);

export const RA_CATEGORY_LABELS = Object.freeze({
  unlicensed: 'Unlicensed',
  prototype: 'Prototype',
  homebrew: 'Homebrew',
  demo: 'Demo',
  hack: 'Hack',
  test_kit: 'Test Kit',
});
export const RA_PREFIXES = Object.freeze(Object.entries(RA_CATEGORY_LABELS)
  .map(([gameType, label]) => Object.freeze({ prefix: `~${label}~`, gameType, label })));
